import { render, staticRenderFns } from "./Soldout.vue?vue&type=template&id=309fa79b"
import script from "./Soldout.vue?vue&type=script&lang=ts"
export * from "./Soldout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports